import React from 'react';
import './RocketLogo.css';

interface RocketLogoProps {
  className?: string;
}

const RocketLogo: React.FC<RocketLogoProps> = ({ className = '' }) => {
  return (
    <div className={`rocket-logo ${className}`}>
      <svg
        width="40"
        height="40"
        viewBox="0 0 100 100"
        xmlns="http://www.w3.org/2000/svg"
        className="rocket-svg"
      >
        {/* Flame/Exhaust */}
        <g className="rocket-flame">
          <ellipse cx="50" cy="85" rx="8" ry="12" fill="#FF6B35" opacity="0.8">
            <animate
              attributeName="ry"
              values="12;16;12"
              dur="0.3s"
              repeatCount="indefinite"
            />
            <animate
              attributeName="opacity"
              values="0.8;1;0.8"
              dur="0.3s"
              repeatCount="indefinite"
            />
          </ellipse>
          <ellipse cx="50" cy="88" rx="6" ry="8" fill="#FFB800" opacity="0.9">
            <animate
              attributeName="ry"
              values="8;12;8"
              dur="0.25s"
              repeatCount="indefinite"
            />
          </ellipse>
        </g>

        {/* Rocket Body */}
        <g className="rocket-body">
          {/* Main body */}
          <rect x="38" y="35" width="24" height="45" rx="2" fill="#667eea" />

          {/* Nose cone */}
          <path d="M 50 10 L 38 35 L 62 35 Z" fill="#764ba2" />

          {/* Window */}
          <circle cx="50" cy="48" r="6" fill="#34d399" opacity="0.3" />
          <circle cx="50" cy="48" r="4" fill="#fff" opacity="0.8" />

          {/* Side fins */}
          <path d="M 38 60 L 28 75 L 38 75 Z" fill="#764ba2" />
          <path d="M 62 60 L 72 75 L 62 75 Z" fill="#764ba2" />

          {/* Details/panels */}
          <rect x="40" y="38" width="20" height="2" fill="#764ba2" opacity="0.3" />
          <rect x="40" y="58" width="20" height="2" fill="#764ba2" opacity="0.3" />
        </g>

        {/* Stars around rocket */}
        <g className="stars">
          <circle cx="20" cy="30" r="1.5" fill="#FFB800" opacity="0.8">
            <animate
              attributeName="opacity"
              values="0.3;1;0.3"
              dur="2s"
              repeatCount="indefinite"
            />
          </circle>
          <circle cx="80" cy="40" r="1.5" fill="#34d399" opacity="0.8">
            <animate
              attributeName="opacity"
              values="0.8;0.3;0.8"
              dur="1.5s"
              repeatCount="indefinite"
            />
          </circle>
          <circle cx="75" cy="20" r="1" fill="#667eea" opacity="0.8">
            <animate
              attributeName="opacity"
              values="0.5;1;0.5"
              dur="1.8s"
              repeatCount="indefinite"
            />
          </circle>
          <circle cx="25" cy="50" r="1" fill="#FFB800" opacity="0.8">
            <animate
              attributeName="opacity"
              values="1;0.3;1"
              dur="2.2s"
              repeatCount="indefinite"
            />
          </circle>
        </g>
      </svg>
    </div>
  );
};

export default RocketLogo;
